export default __webpack_public_path__ + "static/richtmyre-f96a0ac3f1546591309290bc08270224.jpg";